<template>
  <div>
    <div class="vpc-resource-title">
      <div>{{ $t("RAM.TENCENT.VPC.title") }}</div>
      <div>
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:tencent:vpcResource:update'
          ]"
          :loading="updateLoading"
          @click="update"
          >{{ $t("RAM.common.update") }}</Button
        >
        <Button
          type="primary"
          v-hasPermission="[
            'resourceConfigurationManagement:tencent:vpcResource:export'
          ]"
          :loading="modal_loading"
          @click="exportList"
          >{{ $t("common.export") }}</Button
        >
      </div>
    </div>
    <vpc-resource-search ref="child"></vpc-resource-search>
    <table-vpc-resource></table-vpc-resource>
  </div>
</template>

<script>
import VpcResourceSearch from "./VpcResourceSearch.vue";
import TableVpcResource from "./TableVpcResource.vue";
let tableVpcResource = TableVpcResource;

export default {
  name: "VpcResource",
  components: {
    VpcResourceSearch,
    TableVpcResource
  },
  data() {
    return {
      updateLoading: false,
      modal_loading: false
    };
  },
  methods: {
    update() {
      this.updateLoading = true;
      this.$api.resourceManagement
        .updateTencentResource({
          companyId: this.$refs.child.companyId,
          accountIdList: this.$refs.child.accountSearchKey,
          resourceManagement: 608,
          accountType: 6
        })
        .then(res => {
          this.updateLoading = false;
          this.$Message.success(this.$t("common.updateSuccess"));
          setTimeout(() => {
            tableVpcResource.methods.showAll();
          }, 1000);
        })
        .catch(() => {
          this.updateLoading = false;
          this.$Message.error(this.$t("common.updateFail"));
        });
    },
    exportList() {
      let exportDTO = {
        companyId: this.$refs.child.companyId,
        accountIds: this.$refs.child.accountSearchKey,
        accountName: this.$refs.child.accountName
      };
      this.modal_loading = true;
      this.$Message.loading({
        duration: 0,
        content: this.$t("common.exporting")
      });
      this.$api.resourceManagement.exportTencentVpc(exportDTO).then(res => {
        let fileName = this.$t("RAM.export.tencentVpc");
        let blob = new Blob([res.data], { type: "application/x-xls" });
        if (window.navigator.msSaveOrOpenBlob) {
          navigator.msSaveBlob(blob, fileName);
        } else {
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.success(this.$t("common.exportSuccess"));
      }).catch(() => {
        this.modal_loading = false;
        this.$Message.destroy();
        this.$Message.error(this.$t("common.exportFail"));
      });
    }
  }
};
</script>

<style scoped>
.vpc-resource-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 0px 4px;
  font-weight: 600;
  overflow: hidden;
}
.vpc-resource-title > div:nth-child(1) {
  float: left;
}
.vpc-resource-title > div:nth-child(2) {
  float: right;
  margin-top: -6px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/tencent/vpc/VpcResource.vue